<template>
  <div>
    <CompanyInfoBar
      :companyCode="companyCode"
      @backPress="cancelItem"
    ></CompanyInfoBar>
    <div class="tabs ly-border-radius">
      <el-tabs v-model="activeName" class="ly_tabs" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="basicInfo">
          <Info
            ref="basicInfo"
            :enterpriseInfo.sync="enterpriseInfo"
            :enterpriseType="enterpriseType"
          ></Info>
        </el-tab-pane>
        <!-- 数据元信息标签页 -->
        <el-tab-pane label="数据元信息" name="metadata">
          <metadata-info ref="metadata" :enterpriseInfo.sync="enterpriseInfo" />
        </el-tab-pane>

        <!-- 手动标签标签页 -->
        <el-tab-pane label="手动标签" name="manualTags">
          <tag-editor
            ref="manualTags"
            :enterpriseType="enterpriseType"
            :companyCode="String(companyCode)"
            :companyId="String(companyId)"
          />
        </el-tab-pane>

        <!-- 数据日志标签页 -->
        <el-tab-pane label="数据日志" name="dataLog">
          <log-table ref="dataLog" :enterpriseInfo.sync="enterpriseInfo" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="editEnterprise" ref="editEnterprise">
      <div class="bottom">
        <!-- <el-button type="primary" @click="backPress" plain icon="ali-icon-back"
          >返回上级</el-button
        > -->

        <el-button type="primary" @click="saveItem(activeName)">保存</el-button>

        <el-button @click="cancelItem">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 顶部企业信息
import CompanyInfoBar from "@/components/CompanyInfoBar/index.vue";
import Info from "./components/info";
import metadataInfo from "./components/metadataInfo";
import tagEditor from "./components/tagEditor";
import logTable from "./components/logTable";
const defaultEnterpriseInfo = Object.freeze({});
export default {
  components: {
    CompanyInfoBar,
    Info,
    metadataInfo,
    tagEditor,
    logTable,
  },
  data() {
    return {
      activeName: "basicInfo",
      enterpriseInfo: { ...defaultEnterpriseInfo },
      companyId:""
    };
  },
  created() {
    this.companyId = this.$route.query.id;
  },
  computed: {
    companyCode() {
      return this.$route.query.companyCode;
    },
    enterpriseType() {
      return Number(this.$route.query.enterpriseType);
    },
  },
  methods: {
    cancelItem() {
      this.$router.go(-1);
      this.$router.push({
        path: "/superIndividual",
      });
    },
    handleClick() {},
    saveItem() {},
    cancelItem() {},
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-textarea .el-input__count {
  background-color: transparent !important;
}

.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    align-items: center;

    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #333333;
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  .company_center {
    display: flex;

    .label {
      font-size: 16px;
      color: #333333;
    }

    .company_data {
      margin-right: 45px;

      .value_num {
        margin-top: 8px;
        height: 43px;
        line-height: 43px;
        font-size: 22px;
        font-weight: 500;
        text-align: center;
      }
    }

    .company_circle {
      // .circle_content {
      //   margin-top: 8px;
      //   width: 50px;
      //   height: 50px;
      // }
    }

    .company_circle,
    .company_data {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .company_right {
    display: flex;

    .back-icon {
      width: 18px;
      height: 18px;
    }

    .context {
      line-height: 18px;
    }

    .company_button {
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    .company_edit_info {
      margin-left: 20px;
      font-size: 14px;
      color: #999999;

      .company_edit_item {
        display: flex;
        align-items: center;

        p {
          height: 20px;
          line-height: 20x;
        }

        img {
          margin-right: 5px;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}

/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  // margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  border-radius: 0 0 4px 4px;
  .el-button {
    margin: 0 20px;
  }
}

// tabs样式
.ly_tabs {
  background: #fff;
  padding: 0 20px;
}
.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px;
}
.el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
}
.company .company_left .info .fullName[data-v-92b4247e] {
  margin-bottom: 10px;
}
// /deep/.tabs {
//   height: calc(100vh - 312px) !important;
//   overflow: hidden !important;
// }
</style>
